import { render, staticRenderFns } from "./list-campaign.vue?vue&type=template&id=190d842f"
import script from "./list-campaign.vue?vue&type=script&lang=js"
export * from "./list-campaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports